import { css } from 'lit'
import { csSpacing } from '@cloudsuite/mosaic-shared/styles/spacing.style.js'

const styles = {
  segmentedControlFontFamily: css`var(--csc-delivery-match-segmented-control-font-family)`,
  segmentedControlFontWeight: css`var(--csc-delivery-match-segmented-control-font-weight)`,
  segmentedControlTextTransform: css`var(--csc-delivery-match-segmented-control-text-transform)`
}

export const mapStyle = css`
  .selected-method {
    background: var(--cse-selectable-background-color);
    padding: ${csSpacing.spacing06};
  }

  .delivery-match-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: ${csSpacing.spacing05};
    flex: 1;
  }

  .hidden {
    display: none;
  }

  cse-expandable {
    --cse-expandable-toggle-align: center;
    --cse-expandable-list-incremental-row-gap: ${csSpacing.spacing05};
  }

  cse-segmented-control {
    --cs-font-body-font-family: ${styles.segmentedControlFontFamily};
    --cs-font-body-font-weight: ${styles.segmentedControlFontWeight};
    --cs-font-body-text-transform: ${styles.segmentedControlTextTransform};
  }
`
